/**
 * @generated SignedSource<<8dfa72976152684d01fb161a2e99c988>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "request"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "FondySignResponse",
    "kind": "LinkedField",
    "name": "fondySign",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "signature",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "orderId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "reservationData",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "confirmConfirmImplComponentsFondySignMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "confirmConfirmImplComponentsFondySignMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1c8a870ac4f3098eca686db9abd70ba6",
    "id": null,
    "metadata": {},
    "name": "confirmConfirmImplComponentsFondySignMutation",
    "operationKind": "mutation",
    "text": "mutation confirmConfirmImplComponentsFondySignMutation(\n  $request: FondySignRequestInput\n) {\n  fondySign(request: $request) {\n    signature\n    orderId\n    reservationData\n  }\n}\n"
  }
};
})();

node.hash = "833b4a86a93565fcd045811a7cc719a7";

module.exports = node;
